module.exports = __webpack_public_path__ + "img/23 Gesamt Siegerfoto (2).jpg";